:host {
    a {
        @include font(light);

        background: none;
        border: 0;
        color: $color-gray-text;
        cursor: pointer;
        outline: 0;
        text-decoration: underline;
        transition: color 500ms ease;

        &:hover {
            color: $color-black-text;

            .ux-icon[name="arrow-small-right"] {
                transform: translateX(5px);
            }
        }
    }

}

:host([variant='primary']) {
    a {
        color: $theme-color-primary;
        text-decoration: none;
    }

}

:host([variant='current']) {
    a {
        color: currentColor;
        text-decoration: underline;
    }

}

:host([strong]) {
    a {
        @include font(bold);
    }

}

.ux-icon {
    margin: 0 0.3em;
    transition: transform $animationSpeed-fast;
}

.ux-icon__svg {
    fill: currentcolor;
}